import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Sunraf InfoTech</h1>
          <p>
            Transforming healthcare through innovative software solutions
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="company-overview">
        <div className="container">
          <div className="overview-content">
            <div className="overview-text">
              <h2>Who We Are</h2>
              <p>
                Sunraf InfoTech is a specialized software services company with a strong 
                focus on healthcare technology. We understand the unique challenges faced 
                by healthcare organizations and develop custom solutions that address 
                these specific needs.
              </p>
              <p>
                Our team combines deep technical expertise with healthcare industry knowledge 
                to deliver software solutions that are not only technically sound but also 
                practical and user-friendly for medical professionals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission">
              <h3>Our Mission</h3>
              <p>
                To empower healthcare organizations with secure, efficient, and 
                user-friendly digital solutions that improve patient care and 
                streamline operations.
              </p>
            </div>
            <div className="vision">
              <h3>Our Vision</h3>
              <p>
                To be the leading provider of healthcare software solutions, 
                helping medical organizations worldwide embrace digital transformation 
                for better patient outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="expertise">
        <div className="container">
          <h2>Our Expertise</h2>
          <div className="expertise-grid">
            <div className="expertise-item">
              <h4>Healthcare Technology</h4>
              <p>Deep understanding of healthcare workflows, compliance requirements, and industry standards.</p>
            </div>
            <div className="expertise-item">
              <h4>Custom Web Applications</h4>
              <p>Building scalable, secure web applications tailored to specific healthcare needs.</p>
            </div>
            <div className="expertise-item">
              <h4>Role-Based Portals</h4>
              <p>Developing user-specific interfaces for different healthcare roles and responsibilities.</p>
            </div>
            <div className="expertise-item">
              <h4>Data Security</h4>
              <p>Implementing robust security measures to protect sensitive patient information.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container">
          <h2>Ready to Work With Us?</h2>
          <p>
            Let's discuss how we can help transform your healthcare operations 
            with our custom software solutions.
          </p>
          <Link to="/contact" className="btn btn-primary" onClick={scrollToTop}>Get In Touch</Link>
        </div>
      </section>
    </div>
  );
};

export default About;